import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-select-producer',
  templateUrl: './select-producer.component.html'
})
export class SelectProducerComponent implements OnInit {

  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() idProducer: any;

  form = this.fb.group({
    idProducer: ['', [Validators.required]],
    producerName: ['', [Validators.required]],
    producerPhone: ['', [Validators.required]],
  });

  constructor(private authService: AuthenticationService, private fb: FormBuilder) { }

  producers: any;

  ngOnInit(): void {
    this.getProducers();
    this.formReady.emit(this.form);
  }

  getProducers(){
    this.authService.getUsers().then((res:any)=>{
      this.producers = res;
      if(this.idProducer){
        let val = {target: {value: this.idProducer}}
        this.updateProducer(val);
      }
    }, err=>{
      console.log(err);
    })
  }

  updateProducer(data:any){
    let selectedProducer = this.producers.find((x:any)=> x.id == data.target.value);
    this.form.patchValue({
      idProducer: selectedProducer.id,
      producerName: selectedProducer.fullname,
      producerPhone: selectedProducer.telephone,
    });
  }

}
